<template>
  <div
    class="d-flex flex-column min-vh-100 vh-100"
    data-spy="scroll"
    data-target="#mainNav"
    data-offset="75"
  >
    <navigation-main />
    <div class="main-content">
      <main role="main" class="flex-grow-1 overflow-auto">
        <div id="content">
          <section class="page-section bg-light">
            <div class="container">
              <div class="row justify-content-center"></div>
              <h5>Change password</h5>
              <ChangePasswordComponent></ChangePasswordComponent>
            </div>
          </section>
        </div>
      </main>
    </div>
  </div>
</template>

<script>
import NavigationMain from "@/views/navigation/navigation-main";
import ChangePasswordComponent from "@/views/user_management/ChangePasswordComponent";
export default {
  name: "UserSettingsPage",
  components: { NavigationMain, ChangePasswordComponent },

  data() {
    return {};
  },

  methods: {}
};
</script>
<style scoped></style>
